export const API_BASE =
    process.env.NODE_ENV === "development"
        ? "http://localhost:5043"
        : "https://api.learnorama.in";
        
